import { Fragment, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import Agent from './Agent';
import Self from './Self';

const NewConfirmation = () => {
  const { state } = useLocation();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const comeTo = state?.comeTo;
  const rsvTp = comeTo === 'ptcard' ? '1' : state?.rsvTp;
  const scrnTitlNm = state?.scrnTitlNm;
  useEffect(() => {
    navigate('/confirmation', {
      replace: true,
      state: {
        rsvTp: searchParams.get('rsvTp'),
        scrnTitlNm: searchParams.get('scrnTitlNm'),
        hspId: searchParams.get('hspId'),
        usrId: searchParams.get('usrId'),
        userNm: searchParams.get('userNm'),
        userBirthday: searchParams.get('userBirthday'),
        sucsRedirectURL: searchParams.get('sucsRedirectURL'),
        failRedirectURL: searchParams.get('failRedirectURL'),
        failconnRedirectURL: searchParams.get('failconnRedirectURL'),
        sexTpCd: searchParams.get('sexTpCd'),
        hspCd: searchParams.get('hspCd'),
        telNo: searchParams.get('telNo'),
        nativeGb: searchParams.get('nativeGb'),
        ccrcReqId: searchParams.get('ccrcReqId'),
        rlnmUseYn: searchParams.get('rlnmUseYn'),
        ptInfoWrtPsbYn: searchParams.get('ptInfoWrtPsbYn'),
        comeTo: searchParams.get('comeTo'),
        ptNoCreAddrSndYn: searchParams.get('ptNoCreAddrSndYn'),
        failPatientRedirectURL: searchParams.get('failPatientRedirectURL'),
        moduleType: searchParams.get('moduleType'),
        guideUrl: searchParams.get('guideUrl'),
      },
    });
  }, []);

  useEffect(() => {
    if (scrnTitlNm) {
      document.querySelector('title').innerHTML = scrnTitlNm;
    }
  }, [scrnTitlNm]);

  return (
    <Fragment>
      <h1 className='screen_out'>카카오헬스케어 병원톡</h1>
      <div className='container-doc container-guide'>
        <Routes>
          <Route path='/*' element={rsvTp === '1' ? <Self /> : <Agent />} />
        </Routes>
      </div>
    </Fragment>
  );
};

export default NewConfirmation;
